import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class Period extends BaseEntity{
    
    periodCode : string;
    name : string;
    startDate : Date;
    endDate : Date;
    workingDays : number;
    active : boolean;
    periodActiveDay : Date;
    closed : boolean;
    calculationStartDate : Date;
    calculationEndDate : Date;
    referenceStartDate : Date;
    referenceEndDate : Date;
    targetValidated : boolean;

}
